import { useCallback } from 'react';
import { useDialog } from './useDialog';

interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

export const useConfirm = () => {
  const { confirm } = useDialog();

  const confirmDialog = useCallback(
    async (options: ConfirmOptions): Promise<boolean> => {
      return confirm({
        title: options.title,
        content: options.message,
        confirmText: options.confirmText,
        cancelText: options.cancelText,
      });
    },
    [confirm]
  );

  return { confirm: confirmDialog };
};
